import * as React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import CheckBoxChecked from "./checkbox-checked-icon";
import CheckBoxUnChecked from "./checkbox-unchecked-icon";
import { CheckboxProps } from "./types";
import "./styles.scss";

const classNameBase = "scd-checkbox";

export default function CustomCheckbox(
  props: CheckboxProps,
): React.JSX.Element {
  const {
    disabled,
    checked,
    onChange,
    onBlur,
    id,
    label,
    error,
    errorText,
    descriptionText,
  } = props;

  const checkBoxClassName =
    `${classNameBase}-wrapper` +
    `${error ? ` ${classNameBase}-wrapper-error` : ""}` +
    `${disabled ? ` ${classNameBase}-wrapper-disabled` : ""}`;

  return (
    <FormControl error={error} className={checkBoxClassName}>
      <FormControlLabel
        className={classNameBase}
        classes={{ label: `${classNameBase}-label` }}
        control={
          <Checkbox
            id={id}
            checked={checked}
            onChange={onChange}
            onBlur={onBlur}
            color="primary"
            disabled={disabled}
            className={`${classNameBase}-base`}
            icon={<CheckBoxUnChecked />}
            checkedIcon={<CheckBoxChecked />}
            value="checkedH"
          />
        }
        label={label}
      />
      {error && errorText && (
        <FormHelperText className={`${classNameBase}-error`}>
          {errorText}
        </FormHelperText>
      )}
      {descriptionText && (
        <FormHelperText className={`${classNameBase}-description`}>
          {descriptionText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
